import { useIsABTest } from "@/hooks/useIsABTest";
import { useQuizContext } from "@/pages/quiz/context";
import { QuizIDs } from "@/pages/quiz/context/common";

const useIsShowHelpButtonT22 = (quizId: string) => {
  const { answers } = useQuizContext();
  const { isABTest_22_1, isABTest_22_2 } = useIsABTest();

  const selectTreatmentQuestion = Object.values(answers)?.find(
    (a) =>
      a.blockName === "custom-select-treatment-option-bundle" ||
      a.blockName === "custom-select-treatment-option"
  ) as { isAnswered: boolean };

  const isSelectedTreatmentAnswered =
    selectTreatmentQuestion?.isAnswered || false;

  const isQuizWithNewDesign = quizId === QuizIDs["12000"];

  const shouldShowHelpButtonT22Variant1 = isQuizWithNewDesign && isABTest_22_1;
  const shouldShowHelpButtonT22Variant2 =
    isQuizWithNewDesign && isSelectedTreatmentAnswered && isABTest_22_2;

  const isDefaultHelpButtonHidden = isABTest_22_1 || isABTest_22_2;

  return {
    shouldShowHelpButtonT22:
      shouldShowHelpButtonT22Variant1 || shouldShowHelpButtonT22Variant2,
    isDefaultHelpButtonHidden,
  };
};

export { useIsShowHelpButtonT22 };
